import { Component, inject, DestroyRef, input, effect, output } from "@angular/core";
import { CdkDropList, type CdkDragDrop } from "@angular/cdk/drag-drop";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

import { DragAndDropService } from "../drag-and-drop.service";

@Component({
    selector: "wk-drop-list",
    templateUrl: "./drop-list.component.html",
    styleUrl: "./drop-list.component.scss",
    host: {
        class: "wk-drop-list",
    },
    hostDirectives: [
        {
            directive: CdkDropList,
            inputs: [
                "cdkDropListAutoScrollDisabled",
                "cdkDropListData",
                "cdkDropListDisabled",
                "cdkDropListOrientation",
                "cdkDropListSortingDisabled",
            ],
            outputs: ["cdkDropListDropped"],
        },
    ],
})
export class DropListComponent {
    private readonly dragAndDropService = inject(DragAndDropService);
    private readonly dropList = inject<CdkDropList<unknown>>(CdkDropList);
    private readonly destroyRef = inject(DestroyRef);

    groupId = input<string>();
    autoScrollStep = input<number>(32);
    dropped = output<CdkDragDrop<unknown>>();

    constructor() {
        effect(() => {
            const groupId = this.groupId();
            if (!groupId) return;

            this.dropList.id = this.dropList.element.nativeElement.id;
            this.dragAndDropService.registerDropList(groupId, this.dropList);
        });

        effect(() => {
            const groupId = this.groupId();
            const registry = this.dragAndDropService.registeredDropLists();
            if (!groupId || !registry.size) return;

            this.dropList.connectedTo = registry.get(groupId)?.connectedDropLists || [];
        });

        effect(() => {
            const step = this.autoScrollStep();
            this.dropList.autoScrollStep = step;
        });

        this.dropList.autoScrollDisabled = false;
        this.dropList.entered.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e) => this.dragAndDropService.onDropListEntered(e));
        this.dropList.dropped.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((e) => {
            if (this.dragAndDropService.onDropListDropped(e)) {
                this.dropped.emit(e);
            }
        });
    }
}
